import { render, staticRenderFns } from "./ContestOfferSummaryBidderDetailsView.vue?vue&type=template&id=1effd510&scoped=true&"
import script from "./ContestOfferSummaryBidderDetailsView.vue?vue&type=script&lang=js&"
export * from "./ContestOfferSummaryBidderDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1effd510",
  null
  
)

export default component.exports